import { Get, Remove, Set } from "../../../../../Request";

export const FormSubmit = async data => {
  await Set({
    url: "/contentbox/store",
    data: data,
  });
};
export const GetData = async (pageNumber, limit = 15) => {
  return await Get({
    url: "/contentbox/list",
    data: {
      limit: limit,
    },
    page: pageNumber,
  }).then(data => {
    return data;
  });
};
export const DeleteData = async data => {
  await Remove({
    url: "/contentbox/delete",
    data: data,
  });
};
export const EditData = async data => {
  await Set({
    url: "/contentbox/edit",
    data: data,
  });
};
